<template>
  <div class="layout">
    <PcHeader v-if="!isH5" />
    <SearchGame v-if="isH5" />
    <div class="wrapp">
      <van-row v-if="isH5"  gutter="20">
        <van-col span="3">
           <img src="https://cdn.hotplaydl.com/static/img/logo.png" alt="" class="img"  @click="down">
        </van-col>
        <van-col span="12">
            <button class="down" @click="down">Download GamesToday App(V{{version}} &nbsp;{{size}}MB)</button>
        </van-col>
    </van-row>
      <onegame v-for="(item,index) in datas" :key="index" :item="item" />
      <van-pagination
        v-if="datas.length > 1"
        v-model="currentPage" 
        :total-items="total" 
        :items-per-page="20"
        class="pages"
        @change="changePage"
      />
      <div class="email" v-if="datas != ''">hotplaygames@hotmail.com</div>
      <div v-if="datas && datas.length == 0">
        <van-empty description="No results found" />
      </div>
    </div>
  </div>
</template>
<script>
import onegame from '@/components/onegame.vue'
import DownBack from '@/components/downBack.vue'
import SearchGame from '@/components/searchGame.vue'
import PcHeader from '@/components/PcHeader.vue'

import { query } from '@/util/ourplay'
import resizeMixin from '@/mixins/resizeMixin'
import downMixin from '@/mixins/downMixin'
export default {
  components: {
    onegame,
    DownBack,
    SearchGame,
    PcHeader
  },
  mixins: [resizeMixin,downMixin],
  data () {
    return {
      value: '',
      datas:[],
      currentPage:1,
      page:1,
      total:20,
      baseURL: 'http://api.ourplay.net'
    }
  },
  watch:{
    value(nval, oval) {
      document.title = document.title.replace(/『(.*?)』/gi, `『${nval}』`)
    }
  },
  methods: {
    down() {
      location.href = this.url
    },
    async onSearch() {
      if( this.value == ''){
          this.$toast({
            message:"The input value is null"
          });
      } else {
        let res = await query({ page: 1, pageSize: 20, apkName: this.value })
        if( res.total == 0 ) {
          // this.$toast({
          //   message:"No results found"
          // });
          this.datas = []
          location.href = '/errorPage'
        } else {
          this.datas = res.data
          this.total = res.total
        }
      }
    },
    async changePage( p ) {
      this.page = p

      let res = await query({ page: this.page, pageSize: 20, apkName: this.value})
      if( res.total == 0 ) {
        // this.$toast({
        //   message:"No results found"
        // });
        this.datas = []
      } else {
        this.datas = res.data
        this.total = res.total
      }

      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      sessionStorage.setItem("keypage",this.page);
    },
  },
  async created() {
    this.value = this.$route.query.val
    if( this.value == '') {
        this.$toast({
          message:"The input value is null"
        });
    } else {
      let res2 = await query({ page: 1, pageSize: 20, apkName: this.value})
      if( res2.data && res2.data.length == 0) {
        // this.$toast({ message:"No results found" });
        this.datas = []
      } else {
        this.datas = res2.data
        this.total = res2.total
      }
    } 
  }
}

</script>
<style lang="scss" scoped>
.layout {
  .wrapp {
    margin: 16px 12px;
    .img {
      width: 28px;
      height: 28px;
    }
    .down {
      border: 0;
      outline: 0;
      color: #4A90E2;
      vertical-align: top;
      background-color: white;
    }
    .email {
      margin: 12px 0;
      color: #333;
      opacity: .7;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/search.vue